import React, { Fragment } from 'react';

const getSampleRequiredUserResources = (
  selectedClient,
  selectedApi,
  requiredResources,
  domainUrlApp
) => {
  const showCreateClient = !selectedClient && requiredResources.includes('client');
  const showCreateAPI = !selectedApi && requiredResources.includes('api');

  return (showCreateClient || showCreateAPI) &&
    <Fragment>
      { showCreateClient &&
        <a href={`${domainUrlApp}/#/applications`} target="_blank" rel="noreferrer noopener">
          an application
        </a>
      }
      { (showCreateClient && showCreateAPI) && ' and '}
      { showCreateAPI &&
        <a href={`${domainUrlApp}/#/apis`} target="_blank" rel="noreferrer noopener">
          an API
        </a>
      }
    </Fragment>;
};

export default getSampleRequiredUserResources;
